
export const typesTrip = {
  InitAction    : 'Init_Action',
  ErrorAction   : 'Error_Action',
  GetTipsHistory: 'Get_Tips_History',
}